import { render } from "./Servicerequest.vue?vue&type=template&id=3d44155f&scoped=true"
import script from "./Servicerequest.vue?vue&type=script&lang=js"
export * from "./Servicerequest.vue?vue&type=script&lang=js"

import "./Servicerequest.vue?vue&type=style&index=0&id=3d44155f&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d44155f"]])

export default __exports__